import remote from './remote';
import token from './token';
import {phoneNumber} from './defaults';

export {remote, token, phoneNumber};
